import {DataTableColumn} from "mantine-datatable";
import {Meter} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

// FNP-768: the inline Activate / Retire row-action buttons were removed. They were an
// anti-pattern — a SECOND, competing way to change a meter's status alongside the edit
// form's Status radio, which confused operators (and the narrow mutations they called are
// now superseded by the single setMeterStatus door). Meter status transitions now happen
// ONLY through the edit form (RecordsTable appends the standard Edit action), which routes
// to setMeterStatus with server-side lattice + open-period guards and a RETIRE confirm.
export const useTableColumns = () => {

    const columns: DataTableColumn<Meter>[] = [
        {
            accessor: 'name',
            title: I18n.get('Meter'),
            width: '1fr',
        },
        {
            accessor: 'meterCode',
            title: I18n.get('Code'),
            width: '1fr',
            render: (item: Meter) => item.meterCode,
        },
        {
            accessor: 'aggregation',
            title: I18n.get('Aggregation'),
            width: '1fr',
            render: (item: Meter) => item.aggregation,
        },
        {
            accessor: 'grain',
            title: I18n.get('Grain'),
            width: '1fr',
            render: (item: Meter) => item.grain,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Meter) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'dimensions',
            title: I18n.get('Dimensions'),
            width: '1fr',
            render: (item: Meter) => item.dimensions ? item.dimensions.length : '-',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Meter) => formatTimestamp(item.created as string),
        },
    ];

    return {
        columns,
    }
}
